import { useNavigate } from 'react-router-dom';

export default function PrivacyNotice() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a1a', padding: '5rem 1.5rem 4rem', color: '#cbd5e1' }}>
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <button
          onClick={() => navigate(-1)}
          style={{ background: 'none', border: 'none', color: '#818cf8', fontSize: 13, cursor: 'pointer', padding: 0, marginBottom: '2rem', display: 'inline-block' }}
        >← Back</button>

        <h1 style={{ color: '#f8fafc', fontSize: 30, fontWeight: 800, margin: '0 0 0.5rem' }}>Privacy Notice</h1>
        <p style={{ color: '#64748b', fontSize: 13, margin: '0 0 2.5rem' }}>Last updated: April 2026 · admin.privacy.education</p>

        {[
          {
            title: '1. Who we are',
            body: 'privacy.education is an interactive privacy literacy platform. This notice applies to admin.privacy.education — the internal administration portal used by super admins to manage organisations, users, and the platform.',
          },
          {
            title: '2. What we collect',
            body: `As an administrator using this portal, the following data is processed:
• Your admin account email address (enterprise Cognito pool)
• Actions you take in the portal are reflected in downstream data (org creation, user invitations, plan overrides) — these are not separately logged at the portal level
• Data you view: organisation records (name, domain, plan, billing email, seat counts), user records (email, status, assessment scores), and Stripe subscription IDs`,
          },
          {
            title: '3. How we use admin data',
            body: `The portal processes data to:
• Authenticate and authorise administrative access (super admin Cognito group)
• Allow creation and management of enterprise and public organisations
• Display user and assessment data for operational and support purposes
• Manage Stripe billing relationships (customer IDs, subscription IDs — no card data)
Admin access is restricted to individuals explicitly granted the super_admin Cognito group.`,
          },
          {
            title: '4. End-user data you can access',
            body: `As an admin you have access to personal data belonging to end users including:
• Enterprise users: email, name, org membership, assessment results and scores
• Public users: email, account status, plan, org membership
This data must only be accessed and used for legitimate platform administration purposes. Do not export, share, or process this data outside the platform without a lawful basis.`,
          },
          {
            title: '5. Where data is stored',
            body: 'All data is stored in AWS infrastructure in Canada (ca-central-1). Authentication is via AWS Cognito (enterprise pool). Organisation and user records are in Amazon DynamoDB. Assessment results are in a separate DynamoDB table.',
          },
          {
            title: '6. Data retention',
            body: 'Admin accounts are retained for the duration of your employment or engagement. Removal from the super_admin Cognito group revokes access immediately. Underlying user and org data is subject to the respective end-user retention policies.',
          },
          {
            title: '7. Your responsibilities',
            body: `As an admin you are responsible for:
• Keeping your admin credentials secure and not sharing them
• Only accessing data necessary for your administrative role
• Reporting any suspected data breach or misuse to privacy@privacy.education immediately`,
          },
          {
            title: '8. Contact',
            body: 'Questions about this notice or data handling? Email privacy@privacy.education',
          },
        ].map(({ title, body }) => (
          <section key={title} style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#e2e8f0', fontSize: 17, fontWeight: 700, margin: '0 0 0.5rem' }}>{title}</h2>
            <p style={{ fontSize: 14, lineHeight: 1.75, margin: 0, whiteSpace: 'pre-line' }}>{body}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
